import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorService } from 'src/app/shared/services/error.service';
import { VitalService } from 'src/app/shared/services/vital.service';

@Component({
  selector: 'app-vital-upload',
  templateUrl: './vital-upload.component.html',
  styleUrls: ['./vital-upload.component.scss']
})
export class VitalUploadComponent implements OnInit {
  file: File = null;
  @ViewChild('fileInput') fileInput: ElementRef<HTMLElement>;
  scanSuccess : boolean = null;
  loading : boolean = false;
  loadingQuota : boolean = true;
  vitalQuota : number;

  constructor(private router: Router, private vitalService : VitalService, private errorService: ErrorService) {
  }

  ngOnInit() {
    
    this.vitalService.getQuota()
    .then(quota => {
      this.vitalQuota = quota;
      this.loadingQuota = false;
    })
    .catch(e => {
      this.errorService.handlerError(e);
    })
  }

  upload() {
    this.loading = true;
    this.vitalService.upload(this.file)
    .then(record => {
      this.scanSuccess = record != null;
      this.loading = false;
      if(this.scanSuccess) {
        this.router.navigate(['/', 'updates', 'services', 'certtools', 'vitalresults', record.fileinfo.SHA256]);
      } 
    })
    .catch(e => {
      this.scanSuccess = false;
      this.errorService.handlerError(e);
    })
  }

  /* On file select */
  onChange(event) {
    this.file = event.target.files[0];
    this.scanSuccess = null;
  }

  /* trigger a click on the file input element */
  triggerFileInputClick() {
    let el: HTMLElement = this.fileInput.nativeElement;
    el.click();
  }

}
